import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title me-0 flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Consolidated Expenses")
], -1)
const _hoisted_6 = { class: "card-body py-0" }
const _hoisted_7 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoPopup = _resolveComponent("InfoPopup")!
  const _component_ExpensesDonutChart = _resolveComponent("ExpensesDonutChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InfoPopup, { text: "Payments made in other currencies will be converted to EUR for this report based on the current exchange rate." })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ExpensesDonutChart, {
          data: _ctx.data,
          loading: _ctx.loading
        }, null, 8, ["data", "loading"])
      ])
    ])
  ]))
}